import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UploadFile } from '@siemens/element-ng/file-uploader';
import { BaseFileItemComponent } from '../base-file-item';

@Component({
    selector: 'tran-upload-file-item',
    imports: [BaseFileItemComponent],
    templateUrl: './upload-file-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileItemComponent {
    public readonly attachment = input.required<UploadFile>();
    public readonly delete = output<UploadFile>();
}
